export default "__VITE_ASSET__6b49b6c1__"